import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/portfolio/Header";
import Footer from "../components/portfolio/Footer";

// Any path the app does not serve, including retired articles such as
// /project/engram and /project/trace. It says so plainly and offers the two places worth going;
// DocumentHead marks it noindex and the host answers such paths with a 404.

function NotFound() {
  return (
    <div className="pf-home min-h-screen w-full">
      <Header back={{ to: "/", label: "Home" }} />
      <main id="main" tabIndex={-1}>
        <section className="pf-shell pf-work-intro" aria-labelledby="not-found-title">
          <h1 id="not-found-title" className="pf-work-intro__title">
            Page not found
          </h1>
          <p className="pf-work-intro__lead">
            This page is not available. It may have been moved or retired.
          </p>
          <div className="pf-intro__actions">
            <Link to="/" className="pf-pill">
              Go to the homepage
            </Link>
            <Link to="/work" className="pf-pill">
              See all work
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default NotFound;
